var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSermonTextBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 49,
    viewBox: "0 0 359 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.265C0 25.265 11.3851 21.565 12.2078 16.62C13.0305 11.675 19.6062 5.901 26.3814 7.343C30.2839 6.106 28.0258 4.87 28.0258 4.87C28.0258 4.87 27.4095 0.128 35.622 0.128H322.393C322.393 0.128 331.021 -1.315 331.432 5.489C334.924 5.283 344.373 8.581 345.605 13.941C346.837 19.301 353.412 24.22 358.751 25.265C355.875 25.3071 353.098 26.3272 350.863 28.1614C348.628 29.9957 347.066 32.5379 346.427 35.38C345.401 40.74 338.21 43.832 332.458 42.594C331.226 43.832 332.663 48.572 327.733 48.572H31.1057C31.1057 48.572 26.5866 48.16 26.5866 43.831C24.5317 44.243 13.8503 43.212 12.0007 34.554C10.151 25.896 0 25.265 0 25.265Z",
    fill: "url(#paint0_linear_25_1179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_1179",
    x1: 201.605,
    y1: 0,
    x2: 201.605,
    y2: 48.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#F4BD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#F6CE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#F4BD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6802"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSermonTextBackground);
export default __webpack_public_path__ + "static/media/sermon-text-background.ae052daf577d9f0f7fb71ab215aa3edc.svg";
export { ForwardRef as ReactComponent };